import { connect } from 'react-redux';
import Signin from '../components/Signin/Signin';
import * as actions from '../redux/actions/Signin';

const mapStateToProps = (state) => {
  return {
    error: state.signin.error,
    pathname: state.router.location.pathname,
    isDisableSignin: state.signin.isDisableSignin,
    latestExpiredPlan: state.accountSetting.latestExpiredPlan,
    isExpiredPlan: state.accountSetting.isExpiredPlan,
  };
};

const mapDispatchToProps = dispatch => ({
  signin(loginInfo) {
    dispatch(actions.signin(loginInfo));
  },

  signout() {
    dispatch(actions.signout());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Signin);



// WEBPACK FOOTER //
// ./src/containers/Signin.js